import tinycolor from 'tinycolor2'

export const defaultLightModeText = '#0b1117'
export const defaultDarkModeText = '#eee'

export const pastelColors = [
  '#feece8',
  '#bae1ff',
  '#ffedb4',
  '#fce9f1',
  '#cafde0',
  '#e8fafe',
  '#ece8fe',
  '#dfaeff',
]

const defaultLightBackground = '#F1F5F8' //gray-9
const defaultDarkBackground = '#666'

const defaultLightBorder = '#F1F5F8' //gray-9
const defaultDarkBorder = '#c9e6ff'

/**
 * Returns [useBlack, value]
 *
 * @param {String} color
 * @return [boolean, number]
 */
export const getContrastYIQ = (color) => {
  const brightness = tinycolor(color).getBrightness()
  // >= 125 is the recommended functionality
  return [brightness >= 180, brightness]
}

/**
 * @param {String} color
 * @param {boolean} isDarkMode
 * @return {String}
 */
export const getTextColor = (color, isDarkMode) => {
  if (color && color !== 'none') return color

  return isDarkMode ? defaultDarkModeText : defaultLightModeText
}

/**
 * @param {String} color
 * @param {boolean} isDarkMode
 * @return {String}
 */
export const getBackgroundColor = (color, isDarkMode) => {
  if (color && color !== 'none') return color

  return isDarkMode ? defaultDarkBackground : defaultLightBackground
}

/**
 * @param {String} color
 * @param {boolean} isDarkMode
 * @return {String}
 */
export const getBorderColor = (color, isDarkMode) => {
  if (color && color !== 'none') return color

  return isDarkMode ? defaultDarkBorder : defaultLightBorder
}

/**
 * Lighten the provided color by an integer percentage amount.
 * i.e. supply a value from 1 to 100 to lighten by.
 *
 * @param {String} color
 * @param {number} amount
 */
export const lighten = (color, amount) => {
  return tinycolor(color).lighten(amount)
}
